import type { FC } from "react";
import { useNavigate } from "react-router-dom";
import { useScanHandler } from "../App";

const KioskView: FC = () => {
    const navigate = useNavigate();
    const { handleScan } = useScanHandler();

    return (
        <div className="fixed inset-0 z-50 bg-slate-900 flex flex-col items-center justify-center p-4">
            <button onClick={() => navigate('/admin')} className="absolute top-6 right-6 text-slate-500 hover:text-white transition-colors">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </button>
            <div className="w-full max-w-2xl aspect-square bg-black rounded-2xl relative shadow-2xl shadow-sky-500/10">
                <div className="w-full h-full flex flex-col items-center justify-center text-slate-600">
                    <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"><path d="M3 3v18h18"/><path d="M7 12v5h12V8H9v4Z"/><path d="M18 8V5"/><path d="M14 8V5"/></svg>
                    <p className="mt-4 text-xl text-center">Inquadra un QR code per iniziare</p>
                </div>
            </div>
            <div className="mt-8 flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
                <button onClick={() => handleScan(true)} className="bg-green-600 hover:bg-green-500 text-white font-bold py-3 px-6 rounded-lg">Simula Scansione Valida</button>
                <button onClick={() => handleScan(false)} className="bg-red-600 hover:bg-red-500 text-white font-bold py-3 px-6 rounded-lg">Simula Scansione Non Valida</button>
            </div>
        </div>
    );
};

export default KioskView;
